import router from "../router";

export const toLogin = () => {
  router
    .replace({
      name: "Login",
    })
    .catch((err) => {
      err;
    });
};

export const toMainPage = () => {
  router
    .replace({
      name: "RegistrationSearch",
    })
    .catch((err) => {
      err;
    });
};

export const dev =
  "https://ctrixwtqlyysyykgiacastktxumhmarriageadminddd.changelifedev.com";

export const prod =
  "https://htmnbasupkfijedottxyvlvffbwimarriageadminddd.changelifeapp.com";
